<template>
    <section id="testimonials" class="w-full py-12 md:py-24 lg:py-32 bg-gray-50 flex items-center justify-center">
        <div class="container px-4 md:px-6">
            <div class="text-center mb-12">
                <h2 class="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl mb-4 text-[#131211] font-modulus-semi-bold">{{ $t("marketing.auto.lo_que_dicen_nuestros_usuarios") }}</h2>
            </div>
            <div v-if="isSm" class="relative h-[500px] overflow-hidden">
                <div class="absolute w-full" :style="{ top: scrollOffset + 'px', transition: 'top 0.5s linear' }"
                    ref="scrollContainer">
                    <div class="bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm border-gray-200 bg-white hover:shadow-xl transition-all duration-500 hover:scale-105 hover:-translate-y-2 group cursor-pointer mb-6"
                        v-for="testimonial in testimonials" :key="testimonial.name + testimonial.text">
                        <div class="@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6">
                            <div class="flex items-center space-x-2">
                                <div class="flex">
                                    <IconStar stroke="2" v-for="star in [1, 2, 3, 4, 5]" :key="star"
                                        class='h-4 w-4 fill-[#FF8A4C] text-[#FF8A4C] transition-all duration-300 group-hover:scale-125' />
                                </div>
                            </div>
                            <h2 class="text-xl text-[#131211] transition-colors duration-300 group-hover:text-[#FF8A4C] font-modulus-semi-bold">
                                {{ testimonial.name }}
                            </h2>
                            <!-- <p class="font-modulus text-lg">{{ testimonial.role }}</p> -->
                        </div>
                        <div class="px-6">
                            <p class="text-md font-modulus text-gray-600 transition-colors duration-300 group-hover:text-gray-800">
                                "{{ testimonial.text }}"
                            </p>
                        </div>
                    </div>
                    <!-- Duplicar para efecto infinito -->
                    <div class="bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm border-gray-200 bg-white hover:shadow-xl transition-all duration-500 hover:scale-105 hover:-translate-y-2 group cursor-pointer mb-6"
                        v-for="testimonial in testimonials" :key="testimonial.name + testimonial.text + '-clone'">
                        <div class="@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6">
                            <div class="flex items-center space-x-2">
                                <div class="flex">
                                    <IconStar stroke="2" v-for="star in [1, 2, 3, 4, 5]" :key="star"
                                        class='h-4 w-4 fill-[#FF8A4C] text-[#FF8A4C] transition-all duration-300 group-hover:scale-125' />
                                </div>
                            </div>
                            <h2 class="text-xl text-[#131211] transition-colors duration-300 group-hover:text-[#FF8A4C] font-modulus-semi-bold">
                                {{ testimonial.name }}
                            </h2>
                            <p class="font-modulus text-lg">{{ testimonial.role }}</p>
                        </div>
                        <div class="px-6">
                            <p class="text-md font-modulus text-gray-600 transition-colors duration-300 group-hover:text-gray-800">
                                "{{ testimonial.text }}"
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                <div class="bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm border-gray-200 bg-white hover:shadow-xl transition-all duration-500 hover:scale-105 hover:-translate-y-2 group cursor-pointer"
                    v-for="testimonial in testimonials" :key="testimonial.name">
                    <div class="@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6">
                        <div class="flex items-center space-x-2">
                            <div class="flex">
                                <IconStar stroke="2" v-for="star in [1, 2, 3, 4, 5]" :key="star"
                                    class='h-4 w-4 fill-[#FF8A4C] text-[#FF8A4C] transition-all duration-300 group-hover:scale-125' />
                            </div>
                        </div>
                        <h2 class="text-xl text-[#131211] transition-colors duration-300 group-hover:text-[#FF8A4C] font-modulus-semi-bold">
                            {{ testimonial.name }}
                        </h2>
                        <p class="font-modulus text-lg">{{ testimonial.role }}</p>
                    </div>
                    <div class="px-6">
                        <p class="text-md font-modulus text-gray-600 transition-colors duration-300 group-hover:text-gray-800">
                            "{{ testimonial.text }}"
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { IconStar } from '@tabler/icons-vue';
export default {
    name: 'TestimonialsSection',
    data() {
        return {
            testimonials: [
                {
                    name: "John Wilson",
                    role: "",
                    text: "Excellent platform, user friendly and great services.",
                },
                {
                    name: "Carlos Ruiz",
                    role: "",
                    text: "Toda la información fue muy clara en el proceso, previo y durante. El guía asignado mostraba mucho conocimiento y se esmeraba en dar un servicio de alta calidad.",
                },
                {
                    name: "Ana Martín",
                    role: "",
                    text: "Gracias por todo el tour lo disfrutamos muchisimo",
                },
                {
                    name: "Luis Pérez",
                    role: "",
                    text: "La comida estaba muy rica pero poca, el catamarán puede estar en mejor estado más que todo en la parte de adentro, lo que si estuvo excelente fue la tripulación y la atención de ellos, y los lugares que nos llevaron",
                },
                {
                    name: "Martin Smith",
                    role: "",
                    text: "Everything was fantastic! We would absolutely use your service again.",
                },
                {
                    name: "Charlie Smith",
                    role: "",
                    text: "The whole experience was amazing. My family and I really enjoyed it!",
                },
            ],
            scrollOffset: 0,
            scrollSpeed: 1,
            testimonialHeight: 0,
            intervalId: null,
            isSm: window.innerWidth < 768,
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.$nextTick(() => {
            const container = this.$refs.scrollContainer;
            if (container) {
                // Calcular la altura de un bloque de testimonios
                const first = container.querySelector('div');
                this.testimonialHeight = first ? first.offsetHeight + 24 : 120; // 24px = mb-6
            }
            this.startScroll();
        });
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        startScroll() {
            this.intervalId = setInterval(() => {
                this.scrollOffset -= this.scrollSpeed;
                const totalHeight = this.testimonials.length * this.testimonialHeight;
                if (Math.abs(this.scrollOffset) >= totalHeight) {
                    this.scrollOffset = 0;
                }
            }, 30);
        },
        handleResize() {
            this.isSm = window.innerWidth < 768;
        },
    },
    components: {
        IconStar,
    },
}
</script>

<style lang="scss" scoped>
.relative {
  height: 500px;
  overflow: hidden;
}
.absolute {
  left: 0;
  width: 100%;
}
</style>